<template>
  <div>
  <div class="value-action-duplicate">
    <i class="icon yule-icon-duplicate" @click="duplicate" :title="$t('models.external_form.duplicate_desc')"></i>
  </div>
  <div class="value-action-pending">
    <i class="icon yule-icon-clock" :title="$t('models.external_form.pending_cloning')"></i>
  </div>
</div>
</template>
<script>
import { EventBus } from '@/EventBus.js';

export default {
  props: ['item', 'column', 'model'],
  methods: {
    duplicate(){
      let event_name = this.model + '_duplicate'
      // @TODO: add name feature here
      let payload = { id: this.item.id }
      EventBus.$emit(event_name, payload)
    }
  }
}
</script>
<style lang="scss" scoped>
.icon{
  display: block;
  color: #656565;
  cursor: pointer;
}
.value-action-pending {
  display: none;
}
</style>



// WEBPACK FOOTER //
// CollectionValueActionDuplicate.vue?aab1a40e